import React from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ComposedChart, Bar, Line, CartesianGrid, XAxis, YAxis, Tooltip } from 'recharts';
import { cleanFilter, updateFilter } from '../../redux/actions/filtroAction';
import ambiente from '../../config/ambienteConfig';

class Proventos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            proventos: [],
        };
    }

    componentDidMount = () => {
        this.updateGrafico();
    }

    updateGrafico = async () => {
        const res = await axios.get(`${ambiente.dev.server}/relatorios/proventosPorAtivo`);
        this.setState({ proventos: res.data });
    }

    render() {
        return (
            <div>
                <div>
                    <ComposedChart width={1000} height={300} data={this.state.proventos}>
                        <XAxis dataKey="nome" />
                        <YAxis yAxisId="left"/>
                        <YAxis yAxisId="right" orientation="right" />

                        <CartesianGrid stoke="#ccc" strokeDasharray="5 5"/>
                        <Bar yAxisId="left" dataKey="div" fill="#4286f4" stackId="a" />
                        <Bar yAxisId="left" dataKey="jcp" fill="#41f44a" stackId="a" />
                        <Bar yAxisId="left" dataKey="alug" fill="#f44170" stackId="a" />
                        <Bar yAxisId="left" dataKey="cupom" fill="#f9b043" stackId="a" />
                        <Bar yAxisId="left" dataKey="rend" fill="#ad43f9" stackId="a" />
                        <Line type="monotone" yAxisId="right" dataKey="razao" stroke="#ff7300" />
                        <Tooltip cursor={false}/>
                    </ComposedChart>
                </div>
            </div>
        );
    }
}

Proventos.propTypes = {
    updateFilter: PropTypes.func.isRequired,
    cleanFilter: PropTypes.func.isRequired,
    filtro: PropTypes.object.isRequired
  };
  
  function mapStateToProps({filtro}) {
    return {
        filtro: filtro
    };
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      updateFilter: filtro => dispatch(updateFilter(filtro)),
      cleanFilter: () => dispatch(cleanFilter())
    };
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(Proventos);



// WEBPACK FOOTER //
// ./src/components/graficos/ProventosAtivos.js